import CollectibleModal from './CollectibleModal'

export * from './CollectibleModal'

export default CollectibleModal
